import { render, staticRenderFns } from "./QuickviewReview.vue?vue&type=template&id=ae0defc6&scoped=true&"
import script from "./QuickviewReview.vue?vue&type=script&lang=js&"
export * from "./QuickviewReview.vue?vue&type=script&lang=js&"
import style0 from "./QuickviewReview.vue?vue&type=style&index=0&id=ae0defc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0defc6",
  null
  
)

export default component.exports